import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiRequest } from './apiClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

/**
 * Step 41 — Session auth context. Reads /api/auth/me on mount; if the
 * httpOnly session cookie is valid the agent's profile is loaded. The
 * legacy Bearer-token API path is unchanged, so existing fetches keep
 * working — this context is purely for the new login/signup UI.
 */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { ok, data } = await apiRequest('GET', `${BACKEND_URL}/api/auth/me`);
      setUser(ok ? data : null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiRequest('POST', `${BACKEND_URL}/api/auth/logout`);
    } catch { /* noop */ }
    setUser(null);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
